<template>
    <div id="openOnAccountCash">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Open On Account Cash</div>
                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'openOnAccountCash'" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'openOnAccountCash'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="OpenOnAccountCash"
                                    mode="remote"
                                    title="Open On Account Cash"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
let msgServer;
export default {
    name: "OpenOnAccountCash",
    metaInfo() {
        return {
            title: "Open On Account Cash | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        batchProcess:0,
        batchNum:"",
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Customer Number',
                field:'cust_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false
            },
            {
                label:'Customer Name',
                field:'cust_name',
                fpFieldType:"text",
                filterable: true,
                hidden:false
            },
            {
                label: "Payment Date",
                field: "payment_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true
            },
            {
                label:'Unapplied Pmt#',
                field:'payment_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false
            },
            {
                label: "Unapplied Payment Amt",
                field: "unapplied_amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number'
            },
            {
                label:'Invoice',
                field:'invoice_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false
            },
            {
                label: "Invoice Date",
                field: "invoice_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true
            },
            {
                label: "Inv Due Date",
                field: "due_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true
            },
            {
                label: "Original Amt",
                field: "amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number'
            },
            {
                label: "Open Amt",
                field: "open_amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number'
            },
            {
                label:'Currency',
                field:'currency',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },
            {
                label:'Order Type',
                field:'order_type',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },
            {
                label:'Aging Bucket',
                field:'aging_bucket',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },
            {
                label:'Sales Person',
                field:'sales_person',
                fpFieldType:"text",
                filterable: true,
                hidden:false
            },
            {
                label:'Credit Person',
                field:'credit_person',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Last Aged",
                field: "last_aged",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: false,
                sortable : false,
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list'
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'open_on_account_cash_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.sort = {field:"id",type:"desc"};
        this.serverParams.stopRequest = true;
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    mounted: function() {
        var self = this;
        self.getPermissions();
    },
    methods: {
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        loadList: function() {
            var self = this;

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/open-on-account-cash",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                      if ( self.action == "export" ||  self.action == "export_queue") {

                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                          if ( self.action == "export" ) {

                              self.excel = data.content.web;
                              var save = document.createElement("a");
                              save.href = self.excel;
                              save.download = data.content.web;
                              save.target = "_blank";

                              document.body.appendChild(save);
                              save.click();
                              document.body.removeChild(save);

                          } else {

                              self.batchProcess = 1;
                              self.batchNum = data.content;
                          }

                        }

                        self.action = "list";
                        self.loadList();
                        return;

                      } else {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                      }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'open-on-account-cash')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/OpenOnAccountCash.vue